import type React from 'react';

interface SvgProps extends React.SVGAttributes<SVGSVGElement> {
  name: SvgIconName;
}

const Svg: React.FC<SvgProps> = ({ name, ...props }) => {
  switch (name) {
    case 'alert-circle':
      return (
        <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="13.6367" cy="14.4297" r="13" className="fill-amber-400" stroke="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6367 14.4297C21.6367 18.848 18.055 22.4297 13.6367 22.4297C9.21844 22.4297 5.63672 18.848 5.63672 14.4297C5.63672 10.0114 9.21844 6.42969 13.6367 6.42969C18.055 6.42969 21.6367 10.0114 21.6367 14.4297ZM14.6367 10.4297C14.6367 10.982 14.189 11.4297 13.6367 11.4297C13.0844 11.4297 12.6367 10.982 12.6367 10.4297C12.6367 9.8774 13.0844 9.42969 13.6367 9.42969C14.189 9.42969 14.6367 9.8774 14.6367 10.4297ZM12.6367 13.4297C12.0844 13.4297 11.6367 13.8774 11.6367 14.4297C11.6367 14.982 12.0844 15.4297 12.6367 15.4297V18.4297C12.6367 18.982 13.0844 19.4297 13.6367 19.4297H14.6367C15.189 19.4297 15.6367 18.982 15.6367 18.4297C15.6367 17.8774 15.189 17.4297 14.6367 17.4297V14.4297C14.6367 13.8774 14.189 13.4297 13.6367 13.4297H12.6367Z"
            className="fill-amber-50"
          />
        </svg>
      );
    case 'move':
      return (
        <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="13.6367" cy="14.4297" r="13" className="fill-[#FBBF24]" stroke="white" />
          <path
            d="M3.63672 9.5C3.63672 10.0523 4.08444 10.5 4.63673 10.5C5.18901 10.5 5.63673 10.0523 5.63673 9.5L5.63673 3.91421L6.92963 5.20711C7.32015 5.59763 7.95332 5.59763 8.34384 5.20711C8.73437 4.81658 8.73437 4.18342 8.34384 3.79289L5.34384 0.792893C5.1563 0.605357 4.90195 0.5 4.63673 0.5C4.37151 0.5 4.11716 0.605357 3.92962 0.792893L0.929613 3.79289C0.539087 4.18342 0.539087 4.81658 0.929613 5.20711C1.32014 5.59763 1.9533 5.59763 2.34383 5.20711L3.63673 3.91421L3.63672 9.5Z"
            fill="#F9FAFB"
            className="fill-info-50 translate-x-[5px] translate-y-2"
          />
          <path
            d="M13.6368 5.5C13.6368 4.94772 13.189 4.5 12.6367 4.5C12.0845 4.5 11.6367 4.94772 11.6367 5.5L11.6367 11.0858L10.3438 9.79289C9.95332 9.40237 9.32016 9.40237 8.92963 9.79289C8.53911 10.1834 8.53911 10.8166 8.92963 11.2071L11.9296 14.2071C12.1172 14.3946 12.3715 14.5 12.6367 14.5C12.902 14.5 13.1563 14.3946 13.3439 14.2071L16.3439 11.2071C16.7344 10.8166 16.7344 10.1834 16.3439 9.79289C15.9533 9.40237 15.3202 9.40237 14.9296 9.79289L13.6367 11.0858L13.6368 5.5Z"
            fill="#F9FAFB"
            className="fill-info-50 translate-x-[5px] translate-y-1.5"
          />
        </svg>
      );
    case 'create':
      return (
        <svg viewBox="0 0 24 24">
          <path d="M20.719 7.031l-1.828 1.828-3.75-3.75 1.828-1.828q0.281-0.281 0.703-0.281t0.703 0.281l2.344 2.344q0.281 0.281 0.281 0.703t-0.281 0.703zM3 17.25l11.063-11.063 3.75 3.75-11.063 11.063h-3.75v-3.75z" />
        </svg>
      );

    case 'unfold-less':
      return (
        <svg id="icon-unfold_less" viewBox="0 0 24 24">
          <path d="M16.594 5.391l-4.594 4.594-4.594-4.594 1.406-1.406 3.188 3.188 3.188-3.188zM7.406 18.609l4.594-4.594 4.594 4.594-1.406 1.406-3.188-3.188-3.188 3.188z" />
        </svg>
      );

    case 'unfold-more':
      return (
        <svg id="icon-unfold_more" viewBox="0 0 24 24">
          <path d="M12 18.188l3.188-3.188 1.406 1.406-4.594 4.594-4.594-4.594 1.406-1.406zM12 5.813l-3.188 3.188-1.406-1.406 4.594-4.594 4.594 4.594-1.406 1.406z" />
        </svg>
      );

    case 'calendar':
      return (
        <svg viewBox="0 0 16 16">
          <path d="M16 3.886V2.9a.5.5 0 00-.5-.5h-2.014V0H10.97v2.514H5.03V0H2.514v2.514H.457A.457.457 0 000 2.971V15.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V3.886zM1.6 5.943h12.686v8.343H1.6V5.943z" />
        </svg>
      );

    case 'warning':
      return (
        <svg viewBox="0 0 48 48">
          <path d="M24 4.8C13.396 4.8 4.8 13.396 4.8 24S13.396 43.2 24 43.2 43.2 34.604 43.2 24 34.604 4.8 24 4.8zM0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z" />
          <path d="M21.6 28.457V11.314h4.8v17.143h-4.8zM21.6 36.686v-4.8h4.8v4.8h-4.8z" />
        </svg>
      );

    case 'paperclip':
      return (
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.33333 7.35834L11.8215 12.8465C12.4724 13.4974 13.5276 13.4974 14.1785 12.8465C14.8294 12.1956 14.8294 11.1403 14.1785 10.4895L8.69036 5.1443C7.38861 3.84255 5.27806 3.84255 3.97631 5.1443C2.67456 6.44604 2.67456 8.55659 3.97631 9.85834L9.46447 15.2035C11.4171 17.1561 14.5829 17.1561 16.5355 15.2035C18.4882 13.2509 18.4882 10.0851 16.5355 8.13245L11.3333 2.91799"
            stroke="#6B7280"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'edit':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24">
          <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
        </svg>
      );

    case 'search':
      return (
        <svg viewBox="0 0 16 16">
          <path d="M5.486 1.6a3.886 3.886 0 100 7.771 3.886 3.886 0 000-7.771zM0 5.486a5.486 5.486 0 1110.971 0A5.486 5.486 0 010 5.486z" />
          <path d="M10.83 9.34a.5.5 0 01.244.134l4.572 4.572a.5.5 0 010 .708l-.892.892a.5.5 0 01-.707 0l-4.573-4.572a.5.5 0 01-.134-.245l-.426-1.915 1.915.426z" />
        </svg>
      );

    case 'cross':
      return (
        <svg viewBox="0 0 14 14">
          <path d="M6.012 7L1 12.012l.988.988L7 7.988 12.012 13l.988-.988L7.988 7 13 1.988 12.012 1 7 6.012 1.988 1 1 1.988 6.012 7z" />
        </svg>
      );

    case 'info':
      return (
        <svg viewBox="0 0 13 14">
          <path d="M6.5 12.2a5.2 5.2 0 100-10.4 5.2 5.2 0 000 10.4zM13 7A6.5 6.5 0 110 7a6.5 6.5 0 0113 0z" />
          <path d="M7.15 5.793v4.643h-1.3V5.793h1.3zM7.15 3.564v1.3h-1.3v-1.3h1.3z" />
        </svg>
      );

    case 'chevron-up':
      return (
        <svg width="12" height="7">
          <path fillRule="evenodd" d="M0 6l1 1 5-5 5 5 1-1-6-6-1 1-5 5z" clipRule="evenodd" />
        </svg>
      );

    case 'chevron-down':
      return (
        <svg width="12" height="7">
          <path fillRule="evenodd" d="M12 1l-1-1-5 5-5-5-1 1 6 6 1-1 5-5z" clipRule="evenodd" />
        </svg>
      );
    case 'details':
      return (
        <svg width="26" height="26" viewBox="0 0 26 26">
          <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
        </svg>
      );

    case 'trashcan':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
        </svg>
      );

    case 'dots-vertical':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
          />
        </svg>
      );
    case 'settings':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      );
    case 'plus':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
        </svg>
      );
    case 'layout':
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="16" height="16" rx="4" fill="currentColor" />
          <path
            d="M3.09961 3.79961C3.09961 3.41301 3.41301 3.09961 3.79961 3.09961H12.1996C12.5862 3.09961 12.8996 3.41301 12.8996 3.79961V5.19961C12.8996 5.58621 12.5862 5.89961 12.1996 5.89961H3.79961C3.41301 5.89961 3.09961 5.58621 3.09961 5.19961V3.79961Z"
            fill="white"
          />
          <path
            d="M3.09961 7.99961C3.09961 7.61301 3.41301 7.29961 3.79961 7.29961H7.99961C8.38621 7.29961 8.69961 7.61301 8.69961 7.99961V12.1996C8.69961 12.5862 8.38621 12.8996 7.99961 12.8996H3.79961C3.41301 12.8996 3.09961 12.5862 3.09961 12.1996V7.99961Z"
            fill="white"
          />
          <path
            d="M10.7996 7.29961C10.413 7.29961 10.0996 7.61301 10.0996 7.99961V12.1996C10.0996 12.5862 10.413 12.8996 10.7996 12.8996H12.1996C12.5862 12.8996 12.8996 12.5862 12.8996 12.1996V7.99961C12.8996 7.61301 12.5862 7.29961 12.1996 7.29961H10.7996Z"
            fill="white"
          />
        </svg>
      );
    case 'material-changes':
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="16" height="16" rx="4" fill="currentColor" />
          <path
            d="M6.57143 4.5625C6.17694 4.5625 5.85714 4.8703 5.85714 5.25C5.85714 5.62969 6.17694 5.9375 6.57143 5.9375L10.5613 5.9375L9.63778 6.82636C9.35883 7.09485 9.35883 7.53015 9.63778 7.79864C9.91673 8.06712 10.369 8.06712 10.6479 7.79864L12.7908 5.73614C12.9247 5.60721 13 5.43234 13 5.25C13 5.06766 12.9247 4.8928 12.7908 4.76386L10.6479 2.70136C10.369 2.43288 9.91673 2.43288 9.63778 2.70136C9.35884 2.96985 9.35884 3.40515 9.63778 3.67364L10.5613 4.5625L6.57143 4.5625Z"
            fill="white"
          />
          <path
            d="M9.42857 11.4375C9.82306 11.4375 10.1429 11.1297 10.1429 10.75C10.1429 10.3703 9.82306 10.0625 9.42857 10.0625L5.43872 10.0625L6.36222 9.17364C6.64117 8.90515 6.64117 8.46985 6.36222 8.20136C6.08327 7.93288 5.63101 7.93288 5.35207 8.20136L3.20921 10.2639C3.07525 10.3928 3 10.5677 3 10.75C3 10.9323 3.07525 11.1072 3.20921 11.2361L5.35207 13.2986C5.63101 13.5671 6.08327 13.5671 6.36222 13.2986C6.64116 13.0302 6.64116 12.5948 6.36222 12.3264L5.43872 11.4375L9.42857 11.4375Z"
            fill="white"
          />
        </svg>
      );
    case 'book':
      return (
        <svg width="16" height="13" viewBox="0 0 16 13" fill="none">
          <path
            d="M8 1.68959V11.4396M8 1.68959C7.12408 1.10765 5.93487 0.75 4.625 0.75C3.31513 0.75 2.12592 1.10765 1.25 1.68959V11.4396C2.12592 10.8576 3.31513 10.5 4.625 10.5C5.93487 10.5 7.12408 10.8576 8 11.4396M8 1.68959C8.87592 1.10765 10.0651 0.75 11.375 0.75C12.6849 0.75 13.8741 1.10765 14.75 1.68959V11.4396C13.8741 10.8576 12.6849 10.5 11.375 10.5C10.0651 10.5 8.87592 10.8576 8 11.4396"
            stroke="#4B5563"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'duplicate':
      return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M3.60039 5.20039C3.60039 4.31674 4.31674 3.60039 5.20039 3.60039H10.0004C10.884 3.60039 11.6004 4.31674 11.6004 5.20039V10.0004C11.6004 10.884 10.884 11.6004 10.0004 11.6004H5.20039C4.31674 11.6004 3.60039 10.884 3.60039 10.0004V5.20039Z"
            fill="currentColor"
          />
          <path
            d="M2.00039 0.400391C1.11674 0.400391 0.400391 1.11673 0.400391 2.00039V6.80039C0.400391 7.68405 1.11674 8.40039 2.00039 8.40039L2.00039 2.00039H8.40039C8.40039 1.11674 7.68405 0.400391 6.80039 0.400391H2.00039Z"
            fill="currentColor"
          />
        </svg>
      );

    case 'submissions':
      return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17 10V3C17 1.89543 16.1046 1 15 1H3C1.89543 1 1 1.89543 1 3V10M17 10V15C17 16.1046 16.1046 17 15 17H3C1.89543 17 1 16.1046 1 15V10M17 10H14.4142C14.149 10 13.8946 10.1054 13.7071 10.2929L11.2929 12.7071C11.1054 12.8946 10.851 13 10.5858 13H7.41421C7.149 13 6.89464 12.8946 6.70711 12.7071L4.29289 10.2929C4.10536 10.1054 3.851 10 3.58579 10H1"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'templates':
      return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 2C1 1.44772 1.44772 1 2 1H16C16.5523 1 17 1.44772 17 2V4C17 4.55228 16.5523 5 16 5H2C1.44772 5 1 4.55228 1 4V2Z"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 10C1 9.44772 1.44772 9 2 9H8C8.55228 9 9 9.44772 9 10V16C9 16.5523 8.55228 17 8 17H2C1.44772 17 1 16.5523 1 16V10Z"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13 10C13 9.44772 13.4477 9 14 9H16C16.5523 9 17 9.44772 17 10V16C17 16.5523 16.5523 17 16 17H14C13.4477 17 13 16.5523 13 16V10Z"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'blocks':
      return (
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3 15C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H7L9 3H13C14.1046 3 15 3.89543 15 5V6M3 15H17C18.1046 15 19 14.1046 19 13V8C19 6.89543 18.1046 6 17 6H7C5.89543 6 5 6.89543 5 8V13C5 14.1046 4.10457 15 3 15Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'tags':
      return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 5H5.01M5 1H10C10.5119 0.999985 11.0237 1.19525 11.4142 1.58579L18.4143 8.58579C19.1953 9.36684 19.1953 10.6332 18.4143 11.4142L11.4142 18.4142C10.6332 19.1953 9.36683 19.1953 8.58579 18.4142L1.58579 11.4142C1.19526 11.0237 1 10.5118 1 10V5C1 2.79086 2.79086 1 5 1Z"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'users':
      return (
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 17H21V15C21 13.3431 19.6569 12 18 12C17.0444 12 16.1931 12.4468 15.6438 13.1429M16 17H6M16 17V15C16 14.3438 15.8736 13.717 15.6438 13.1429M6 17H1V15C1 13.3431 2.34315 12 4 12C4.95561 12 5.80686 12.4468 6.35625 13.1429M6 17V15C6 14.3438 6.12642 13.717 6.35625 13.1429M6.35625 13.1429C7.0935 11.301 8.89482 10 11 10C13.1052 10 14.9065 11.301 15.6438 13.1429M14 4C14 5.65685 12.6569 7 11 7C9.34315 7 8 5.65685 8 4C8 2.34315 9.34315 1 11 1C12.6569 1 14 2.34315 14 4ZM20 7C20 8.10457 19.1046 9 18 9C16.8954 9 16 8.10457 16 7C16 5.89543 16.8954 5 18 5C19.1046 5 20 5.89543 20 7ZM6 7C6 8.10457 5.10457 9 4 9C2.89543 9 2 8.10457 2 7C2 5.89543 2.89543 5 4 5C5.10457 5 6 5.89543 6 7Z"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'photo':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
          />
        </svg>
      );
    case 'support':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75ZM15.25 12C15.25 13.7949 13.7949 15.25 12 15.25V16.75C14.6234 16.75 16.75 14.6234 16.75 12H15.25ZM12 15.25C10.2051 15.25 8.75 13.7949 8.75 12H7.25C7.25 14.6234 9.37665 16.75 12 16.75V15.25ZM8.75 12C8.75 10.2051 10.2051 8.75 12 8.75V7.25C9.37665 7.25 7.25 9.37665 7.25 12H8.75ZM12 8.75C13.7949 8.75 15.25 10.2051 15.25 12H16.75C16.75 9.37665 14.6234 7.25 12 7.25V8.75ZM17.8336 5.10571L14.2981 8.64124L15.3588 9.7019L18.8943 6.16637L17.8336 5.10571ZM14.2981 15.3588L17.8336 18.8943L18.8943 17.8336L15.3588 14.2981L14.2981 15.3588ZM9.7019 8.64124L6.16637 5.10571L5.10571 6.16637L8.64124 9.7019L9.7019 8.64124ZM8.64124 14.2981L5.10571 17.8336L6.16637 18.8943L9.7019 15.3588L8.64124 14.2981Z"
            fill="currentColor"
          />
        </svg>
      );

    case 'block-parent':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 6C2 4.89543 2.89543 4 4 4H8L10 6H14C15.1046 6 16 6.89543 16 8V9H8C6.34315 9 5 10.3431 5 12V13.5C5 14.3284 4.32843 15 3.5 15C2.67157 15 2 14.3284 2 13.5V6Z"
            fill="#6B7280"
          />
          <path
            d="M6 12C6 10.8954 6.89543 10 8 10H16C17.1046 10 18 10.8954 18 12V14C18 15.1046 17.1046 16 16 16H2H4C5.10457 16 6 15.1046 6 14V12Z"
            fill="#6B7280"
          />
        </svg>
      );
    case 'clauses':
      return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 12V15M10 12V15M14 12V15M1 19H19M1 8H19M1 5L10 1L19 5M2 8H18V19H2V8Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'layers-plus':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
          <path
            d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83l-8.59-3.91ZM16 17h6M19 14v6M2 12a1 1 0 0 0 .58.91l8.6 3.91c.26.117.54.178.825.178M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l2.116-.962"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return null;
  }
};

export default Svg;

export type SvgIconName =
  | 'alert-circle'
  | 'blocks'
  | 'block-parent'
  | 'book'
  | 'calendar'
  | 'chevron-down'
  | 'chevron-up'
  | 'clauses'
  | 'create'
  | 'cross'
  | 'details'
  | 'dots-vertical'
  | 'duplicate'
  | 'edit'
  | 'info'
  | 'layers-plus'
  | 'layout'
  | 'material-changes'
  | 'move'
  | 'paperclip'
  | 'photo'
  | 'plus'
  | 'search'
  | 'settings'
  | 'submissions'
  | 'tags'
  | 'templates'
  | 'trashcan'
  | 'unfold-less'
  | 'unfold-more'
  | 'users'
  | 'warning'
  | 'support';
